import { Component } from '@angular/core';

import { QSThermostatService } from './quickstart-thermostats.service';

@Component({
  template: '<router-outlet></router-outlet>',
  providers: [
    QSThermostatService
  ]
})
export class QSThermostatComponent {

}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-thermostats/quickstart-thermostats.component.ts